<div class="docs-wrapper" [attr.data-theme]="theme()">
  <!-- Skip to content for accessibility -->
  <a href="#content" class="skip-link">Naar inhoud</a>

  <!-- Mobile header -->
  <header class="mobile-header" id="mobile-header">
    <button
      class="menu-toggle"
      id="menu-toggle"
      aria-label="Menu openen"
      (click)="toggleMobileMenu()"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      >
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    </button>
    <span class="mobile-title">Handleiding</span>
    <button
      class="theme-toggle"
      id="theme-toggle-mobile"
      aria-label="Wissel thema"
      title="Wissel thema"
      (click)="toggleTheme()"
    >
      <svg
        class="sun-icon"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="4" />
        <path
          d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
        />
      </svg>
      <svg
        class="moon-icon"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
      </svg>
    </button>
  </header>

  <!-- Sidebar -->
  <aside class="sidebar" id="sidebar" [class.open]="mobileMenuOpen()">
    <div class="sidebar-header">
      <div class="logo">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
          <path
            d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
          ></path>
        </svg>
        <span>Handleiding</span>
      </div>
      <button
        class="theme-toggle"
        id="theme-toggle"
        aria-label="Wissel thema"
        title="Wissel thema"
        (click)="toggleTheme()"
      >
        <svg
          class="sun-icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="4" />
          <path
            d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
          />
        </svg>
        <svg
          class="moon-icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
        </svg>
      </button>
    </div>

    <!-- Search -->
    <div class="sidebar-search">
      <div class="search-input-wrapper">
        <svg
          class="search-icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input
          type="text"
          id="search-input"
          placeholder="Zoeken..."
          aria-label="Zoeken in handleiding"
          [ngModel]="searchQuery()"
          (ngModelChange)="searchQuery.set($event)"
          (focus)="preloadOnSearchFocus()"
        />
        <kbd class="search-kbd" title="Sneltoets">Ctrl K</kbd>
      </div>
      <div class="search-results" id="search-results" [hidden]="!showSearchResults()">
        @for (result of searchResults(); track result.slug) {
          <div
            class="search-result-item"
            (click)="selectSlug(result.slug)"
            role="presentation"
          >
            <div
              class="search-result-title"
              [innerHTML]="highlightSearchTerm(result.title)"
            ></div>
            <div
              class="search-result-excerpt"
              [innerHTML]="highlightSearchTerm(result.excerpt)"
            ></div>
          </div>
        } @empty {
          <div class="search-no-results">
            Geen resultaten gevonden voor "{{ searchQuery() }}"
          </div>
        }
      </div>
    </div>

    <!-- Table of contents -->
    <nav class="sidebar-nav" id="sidebar-nav" aria-label="Inhoudsopgave">
      @for (section of manifest()?.sections; track section.title) {
        <div
          class="nav-section"
          [class.collapsed]="section.collapsed"
        >
          <div
            class="nav-section-title"
            role="button"
            tabindex="0"
            [attr.aria-expanded]="!section.collapsed"
            (click)="toggleSection(section)"
            (keydown.enter)="toggleSection(section)"
            (keydown.space)="$event.preventDefault(); toggleSection(section)"
          >
            <span>{{ section.title }}</span>
            <svg
              class="nav-section-chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
          <ul class="nav-section-items">
            <div class="nav-section-items-inner">
              @for (item of section.items; track item.slug) {
                <li class="nav-item">
                  <a
                    [routerLink]="['/docs', item.slug]"
                    [class.active]="currentSlug() === item.slug"
                    (click)="closeMobileMenu()"
                  >
                    <span [innerHTML]="getIconSvg(item.slug)"></span>
                    <span>{{ item.title }}</span>
                  </a>
                </li>
              }
            </div>
          </ul>
        </div>
      }
    </nav>
  </aside>

  <!-- Overlay for mobile sidebar -->
  <div
    class="sidebar-overlay"
    id="sidebar-overlay"
    [class.visible]="mobileMenuOpen()"
    (click)="closeMobileMenu()"
    role="presentation"
  ></div>

  <!-- Main content -->
  <main class="content" id="content">
    @if (breadcrumbs().length > 0) {
      <div class="breadcrumbs-layout">
        <div class="breadcrumbs-container">
          <nav class="breadcrumbs" id="breadcrumbs" aria-label="Kruimelpad">
            <a [routerLink]="['/docs', DEFAULT_SLUG]">Handleiding</a>
            <span class="breadcrumbs-separator">/</span>
            <span>{{ breadcrumbs()[0] }}</span>
            <span class="breadcrumbs-separator">/</span>
            <span class="breadcrumbs-current">{{ breadcrumbs()[1] }}</span>
          </nav>
        </div>
      </div>
    }
    <div class="main-content-layout">
      <div class="main-content-left">
        <!-- Image clicks/keyboard activation are handled via delegated listeners
             attached in ngAfterViewInit (the images come from injected HTML). -->
        <article
          class="prose"
          id="article"
          [innerHTML]="currentArticleHtml()"
        ></article>

        <!-- Footer -->
        @if (prevItem || nextItem) {
          <footer class="content-footer">
            <div class="footer-nav" id="footer-nav">
              @if (prevItem) {
                <a
                  [routerLink]="['/docs', prevItem.slug]"
                  class="footer-nav-link prev"
                >
                  <span class="footer-nav-label">← Vorige</span>
                  <span class="footer-nav-title">{{ prevItem.title }}</span>
                </a>
              }
              @if (nextItem) {
                <a
                  [routerLink]="['/docs', nextItem.slug]"
                  class="footer-nav-link next"
                >
                  <span class="footer-nav-label">Volgende →</span>
                  <span class="footer-nav-title">{{ nextItem.title }}</span>
                </a>
              }
            </div>
          </footer>
        }
      </div>

      <aside
        class="page-outline-container"
        id="page-outline-container"
        [hidden]="outlineItems().length === 0"
      >
        <div class="page-outline-sticky">
          <div class="page-outline-title">Op deze pagina</div>
          <nav
            class="page-outline"
            id="page-outline"
            aria-label="Inhoudsopgave van de pagina"
          >
            @for (head of outlineItems(); track head.id) {
              <a
                href="javascript:void(0)"
                [class.active]="activeOutlineId() === head.id"
                [class.depth-3]="head.depth === 3"
                class="page-outline-link"
                (click)="scrollToHeading(head.id)"
              >
                {{ head.text }}
              </a>
            }
          </nav>
        </div>
      </aside>
    </div>
  </main>

  <!-- Lightbox Modal for full screen image view -->
  <!-- Backdrop click closes (only when the backdrop itself is the target);
       Escape closes via this handler once the dialog is focused on open. -->
  <div
    #lightbox
    class="lightbox"
    [class.open]="lightboxOpen()"
    (click)="onLightboxClick($event)"
    (keydown.escape)="closeLightbox()"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-label="Afbeelding in het groot bekijken"
  >
    <button class="lightbox-close" (click)="closeLightbox()" aria-label="Sluiten">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
    <div class="lightbox-content">
      <img [src]="lightboxImage() || ''" [alt]="lightboxAlt() || ''" class="lightbox-img" decoding="async" />
      @if (lightboxAlt()) {
        <div class="lightbox-caption">{{ lightboxAlt() }}</div>
      }
    </div>
  </div>
</div>
